
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/books/the-staff-engineers-path",
      function () {
        return require("private-next-pages/books/the-staff-engineers-path.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/books/the-staff-engineers-path"])
      });
    }
  